import React from "react";
import { doc, updateDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../config/firebaseConfig";
// import { db } from "../../../config/firebaseInit"; // db ya inicializado en un archivo central

export const StudentsPendinglTableRow = ({
	el,
	setSelectedCourse,
	company,
}) => {
	const buttonAction = async (el) => {
		try {
			const collectionName = "coursesAsignment-" + company;
			const docRef = doc(db, collectionName, el.id);

			// Leer documento fresco
			const docSnap = await getDoc(docRef);
			const courseData = docSnap.data();

			// Registrar dateStartCourse si no existe
			if (!courseData.dateStartCourse) {
				await updateDoc(docRef, {
					dateStartCourse: serverTimestamp(),
				});
			}

			// Actualizar estado con información fresca
			setSelectedCourse({ ...courseData, id: el.id });
		} catch (error) {
			console.error("❌ Error actualizando dateStartCourse:", error);
		}
	};

	// Cambiar color del botón según dateStartCourse
	const buttonClass = el.dateStartCourse
		? "btnReEditDocuments"
		: "btnEditDocuments";

	const date1 = el.initialDate
		? new Date(el.initialDate.seconds * 1000).toLocaleDateString()
		: "-";
	const date2 = el.finalDate
		? new Date(el.finalDate.seconds * 1000).toLocaleDateString()
		: "-";

	return (
		<tr className="fila-tabla-cuenstas">
			<td className="colTableDocuments1">{el.course}</td>
			<td className="colTableDocuments1">{el.status}</td>
			<td className="colTableDocuments1">{Math.round(el.calification)}</td>
			<td className="colTableDocuments1">{date1}</td>
			<td className="colTableDocuments1">{date2}</td>
			<td className="colTableDocuments1">
				<button onClick={() => buttonAction(el)} className={buttonClass}>
					Ingresar
				</button>
			</td>
		</tr>
	);
};

// import React from "react";
// import { doc, updateDoc, getDoc } from "firebase/firestore";
// import { db } from "../../../config/firebaseConfig";
// // import db from "../../../config/firebase"; // ← FIREBASE CENTRALIZADO

// export const StudentsPendinglTableRow = ({
// 	el,
// 	setSelectedCourse,
// 	company,
// }) => {
// 	const date1 = new Date(el.initialDate.seconds * 1000).toLocaleDateString();
// 	const date2 = new Date(el.finalDate.seconds * 1000).toLocaleDateString();

// 	const buttonAction = async () => {
// 		try {
// 			const collectionName = "coursesAsignment-" + company;
// 			const docRef = doc(db, collectionName, el.id);

// 			// 1️⃣ Si NO existe dateStartCourse → lo registramos
// 			if (!el.dateStartCourse) {
// 				await updateDoc(docRef, {
// 					dateStartCourse: new Date().toISOString(), // siempre UTC
// 				});
// 			}

// 			// 2️⃣ LEER DE NUEVO el documento desde Firestore
// 			const freshSnap = await getDoc(docRef);
// 			const freshData = { id: el.id, ...freshSnap.data() };

// 			// 3️⃣ Solo ahora se pasa al padre
// 			setSelectedCourse(freshData);
// 		} catch (error) {
// 			console.error("❌ Error actualizando dateStartCourse:", error);
// 		}
// 	};

// 	// Cambia color del botón
// 	const buttonClass = el.dateStartCourse
// 		? "btnReEditDocuments"
// 		: "btnEditDocuments";

// 	return (
// 		<tr className="fila-tabla-cuenstas">
// 			<td className="colTableDocuments1">{el.course}</td>
// 			<td className="colTableDocuments1">{el.status}</td>
// 			<td className="colTableDocuments1">{Math.round(el.calification)}</td>
// 			<td className="colTableDocuments1">{date1}</td>
// 			<td className="colTableDocuments1">{date2}</td>

// 			<td className="colTableDocuments1">
// 				<button onClick={buttonAction} className={buttonClass}>
// 					Ingresar
// 				</button>
// 			</td>
// 		</tr>
// 	);
// };

// import React from "react";
// import {
// 	doc,
// 	updateDoc,
// 	serverTimestamp,
// 	getFirestore,
// } from "firebase/firestore";
// import { db } from "../../../config/firebaseConfig";
// //import { firebaseConfig } from "../../../config/firebaseConfig";
// //import { initializeApp } from "@firebase/app";

// export const StudentsPendinglTableRow = ({
// 	el,
// 	setSelectedCourse,
// 	company,
// }) => {
// 	// console.log("que hay en company:", company);
// 	//const app = initializeApp(firebaseConfig);
// 	//const db = getFirestore(app);

// 	const date1 = new Date(el.initialDate.seconds * 1000).toLocaleDateString();
// 	const date2 = new Date(el.finalDate.seconds * 1000).toLocaleDateString();

// 	const buttonAction = async (el) => {
// 		try {
// 			const collectionName = "coursesAsignment-" + company;
// 			const docRef = doc(db, collectionName, el.id);

// 			// Si no existe dateStartCourse en el documento, lo grabamos
// 			if (!el.dateStartCourse) {
// 				await updateDoc(docRef, {
// 					dateStartCourse: new Date().toISOString(),
// 					// dateStartCourse: serverTimestamp(),
// 				});
// 				// console.log("✅ dateStartCourse registrado en Firestore");
// 			} else {
// 				// console.log(
// 				// 	"ℹ️ El curso ya tiene dateStartCourse:",
// 				// 	el.dateStartCourse
// 				// );
// 			}

// 			// 👉 Solo ejecutamos esto después de Firestore
// 			setSelectedCourse(el);
// 			// openModal1();
// 		} catch (error) {
// 			console.error("❌ Error actualizando dateStartCourse:", error);
// 		}
// 	};

// 	// ✅ Cambiar color del botón según dateStartCourse
// 	const buttonClass = el.dateStartCourse
// 		? "btnReEditDocuments" // si YA existe → amarillo
// 		: "btnEditDocuments"; // si NO existe → verde

// 	return (
// 		<tr className="fila-tabla-cuenstas">
// 			<td className="colTableDocuments1">{el.course}</td>
// 			<td className="colTableDocuments1">{el.status}</td>
// 			<td className="colTableDocuments1">{Math.round(el.calification)}</td>
// 			<td className="colTableDocuments1">{date1}</td>
// 			<td className="colTableDocuments1">{date2}</td>
// 			<td className="colTableDocuments1">
// 				<button onClick={() => buttonAction(el)} className={buttonClass}>
// 					Ingresar
// 				</button>
// 			</td>
// 		</tr>
// 	);
// };
